import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "10",
  viewBox: "0 0 28 10",
  xmlns: "http://www.w3.org/2000/svg",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".spinner_zWVm{animation:spinner_5QiW 1.2s linear infinite,spinner_PnZo 1.2s linear infinite} .spinner_gfyD{animation:spinner_5QiW 1.2s linear infinite,spinner_4j7o 1.2s linear infinite;animation-delay:.1s} .spinner_E3Wz{animation:spinner_5QiW 1.2s linear infinite,spinner_tDji 1.2s linear infinite;animation-delay:.2s} @keyframes spinner_5QiW{0%,50%{width:7.33px;height:7.33px}25%{width:1.33px;height:1.33px}} @keyframes spinner_PnZo{0%,50%{x:1px;y:1px}25%{x:4px;y:4px}} @keyframes spinner_4j7o{0%,50%{x:10.33px;y:1px}25%{x:13.33px;y:4px}} @keyframes spinner_tDji{0%,50%{x:19.66px;y:1px}25%{x:22.66px;y:4px}}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createElementVNode("rect", {
      class: "spinner_zWVm",
      x: "1",
      y: "1",
      width: "7.33",
      height: "7.33"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("rect", {
      class: "spinner_gfyD",
      x: "10.33",
      y: "1",
      width: "7.33",
      height: "7.33"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("rect", {
      class: "spinner_E3Wz",
      x: "19.66",
      y: "1",
      width: "7.33",
      height: "7.33"
    }, null, -1))
  ]))
}
export default { render: render }